import { Device } from '../models/Device/Device.model';
import { apiClient } from './ApiService';

type CreateDeviceData = {
  name?: string;
  device_type?: string | null;
  description?: string;
  device_uuid?: string;
  serial_number: string;
  organization?: number | null;
  remote_id_number?: string;
  faa_reg_number?: string;
};

type UpdateDeviceData = Partial<CreateDeviceData>;

type ApiResponse<T> = {
  status: number;
  message: string;
  data: T;
};

const getDevices = async (): Promise<Device[]> => {
  // Backend returns a paginated envelope: { status, message, data: { results, count, next, previous } }
  const response = await apiClient.get<{ status: number; message: string; data: { results: Device[] } }>(
    '/drone_commander/devices/all/'
  );
  return response.data.results;
};

/* const getDevices = async (): Promise<Device[]> => {
  const response = await apiClient.get<ApiResponse<Device[]>>('/drone_commander/devices/all/');
  return response.data;
}; */

const createDevice = async (newDeviceData: CreateDeviceData): Promise<Device> => {
  const response = await apiClient.post<ApiResponse<Device>>('/drone_commander/devices/', newDeviceData);
  return response.data;
};

const updateDevice = async (id: string, data: UpdateDeviceData): Promise<Device> => {
  const response = await apiClient.patch<ApiResponse<Device>>(`/drone_commander/devices/${id}/`, data);
  return response.data;
};

const deleteDevice = async (id: string): Promise<void> => apiClient.delete(`/drone_commander/devices/${id}/`, {});

export const SystemDeviceService = {
  getDevices,
  createDevice,
  updateDevice,
  deleteDevice
};
